export const environment = {
  production: true,
  httpApiUrl: 'https://api.vit-connect.de/mv/v1',
  apiUrl: 'https://api.vit-connect.de',
  path: '/mv/v1/socket.io/'
};
